import { InterpreterFrom } from 'xstate'
import { locgMachine } from '@app/code/src/machines/locg/locgMachine'
import { useEnhancedEffect } from '@dtx-company/true-common/src/hooks/useEnhancedEffect'
import { useInterpret } from '@xstate/react'
import React, { FC, ReactNode, createContext } from 'react'
import useTranslation from 'next-translate/useTranslation'

export interface GlobalXStateContextType {
  locgService: InterpreterFrom<typeof locgMachine>
}

export const GlobalXStateContext = createContext<GlobalXStateContextType | undefined>(undefined)

export const XStateProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const { lang } = useTranslation()

  const locgService = useInterpret(locgMachine, { devTools: process.env.APP_ENV === 'development' })

  useEnhancedEffect(() => {
    // Pass the locale to the state machines to make it available in the context
    // so next-translate/getT can be used outside of React components
    locgService.send({ type: 'SET_LOCALE', locale: lang })
  }, [lang])

  return (
    <GlobalXStateContext.Provider value={{ locgService }}>{children}</GlobalXStateContext.Provider>
  )
}
